import {
  getAllLocationsHttp,
  addLocationHttp,
  updateLocationHttp,
  deleteLocationHttp,
  fetchAllLocationsDG2Http,
  getCountHttp,
  getAllLocationsPaginationHttp,
  getAllNotHiddenLocationsHttp,
} from "../../services/planning/LocationServices.js";
import i18n from "@/i18n";

const state = {
  locations: [],
  totalItemCount: null,
};

const getters = {
  getLocations(state) {
    return state.locations;
  },
  getTotalItemCount(state) {
    return state.totalItemCount;
  },
  getLocationById: (state) => (id) => {
    return state.locations.find((c) => c.id === id);
  },
  getDistLocation(state) {
    return state.locations.find((c) => c.city.toLowerCase() === "distance");
  },
};

const mutations = {
  SET_LOCATIONS: (state, data) => (state.locations = data),
  ADD_NEW_LOCATION: (state, payload) => state.locations.push(payload),
  EDIT_LOCATION: (state, payload) => {
    let index = state.locations.findIndex((l) => l.id === payload.id);
    if (index !== -1) state.locations.splice(index, 1, payload);
  },
  REMOVE_LOCATION: (state, payload) => {
    let index = state.locations.findIndex((l) => l.id === payload);
    if (index !== -1) state.locations.splice(index, 1);
  },
  SET_ITEM_COUNT: (state, data) => (state.totalItemCount = data),
};

const actions = {
  /**
   * This method will load all locations from the database
   *
   * @param  {Vuex} {commit necessary if call commit inside the method
   * @param  {Vuex} dispatch} necessary if call dispatch inside the method
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("SET_LOCATIONS", response.data)
   */
  async loadLocations({ commit, dispatch }) {
    await getAllLocationsHttp()
      .then((response) => {
        commit("SET_LOCATIONS", response.data);
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.locationAllError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method will load all locations from the database
   *
   * @param  {Vuex} {commit necessary if call commit inside the method
   * @param  {Vuex} dispatch} necessary if call dispatch inside the method
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("SET_LOCATIONS", response.data)
   */
  async loadNotHiddenLocations({ commit, dispatch }) {
    await getAllNotHiddenLocationsHttp()
      .then((response) => {
        commit("SET_LOCATIONS", response.data);
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.locationAllError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method will load locations depending of page, size and search parameters
   *
   * @param  {Vuex} {commit necessary if call commit inside the method
   * @param  {Vuex} dispatch} necessary if call dispatch inside the method
   * @param  {} {page page number that will be load
   * @param  {} size number of locations that will be load (represents LIMIT in sql)
   * @param  {} search} only locations containing 'search' will be load
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("SET_LOCATIONS", response.data)
   */
  async loadPagincationLocations({ commit, dispatch }, { page, size, search }) {
    await getAllLocationsPaginationHttp(page, size, search)
      .then((response) => {
        commit("SET_LOCATIONS", response.data);
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.locationAllError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   *  This method will give the number of locations containing 'search'
   *
   * @param  {Vuex} {commit necessary if call commit inside the method
   * @param  {Vuex} dispatch} necessary if call dispatch inside the method
   * @param  {} {search} only locations containing 'search' will be counted
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("SET_ITEM_COUNT", response.data.nb)
   */
  async getCount({ commit, dispatch }, { search }) {
    await getCountHttp(search)
      .then((response) => {
        commit("SET_ITEM_COUNT", response.data.nb);
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.locationAllError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to add a location in the database and then in the VueX store
   *
   * @param  {Vuex} {commit necessary if call commit inside the method
   * @param  {Vuex} dispatch} necessary if call dispatch inside the method
   * @param  {Object - locationDto} location object that we want to add in the database
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("ADD_NEW_LOCATION", response.data)
   */
  async addLocation({ commit, dispatch }, location) {
    await addLocationHttp(location)
      .then((response) => {
        commit("ADD_NEW_LOCATION", response.data);
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.locationAddSuccess"),
            typeAlert: "success",
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.locationAddError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to edit a location in the database and then in the VueX store
   *
   * @param  {Vuex} {commit necessary if call commit inside the method
   * @param  {Vuex} dispatch} necessary if call dispatch inside the method
   * @param  {Object - locationDto} location object that we want to edit in the database
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("EDIT_LOCATION", response.data)
   */
  async editLocation({ commit, dispatch }, location) {
    await updateLocationHttp(location)
      .then((response) => {
        commit("EDIT_LOCATION", response.data),
          dispatch(
            "notificationModule/showNotification",
            {
              messageAlert: i18n.t("messageStores.locationEditSuccess"),
              typeAlert: "success",
            },
            { root: true }
          );
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.locationEditError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to delete a location in the database and then in the VueX store
   *
   * @param  {Vuex} {commit necessary if call commit inside the method
   * @param  {Vuex} dispatch} necessary if call dispatch inside the method
   * @param  {Object - locationDto} location object that we want to delete in the database
   * @returns {} it is returning nothing because the response will be load in the store directly => commit("REMOVE_LOCATION", location.id)
   */
  async deleteLocation({ commit, dispatch }, location) {
    await deleteLocationHttp(location.id)
      .then((response) => {
        if (response.status === 202) {
          commit("REMOVE_LOCATION", location.id),
            dispatch(
              "notificationModule/showNotification",
              {
                messageAlert: i18n.t("messageStores.locationDeleteSuccess"),
                typeAlert: "success",
              },
              { root: true }
            );
        }
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.locationDeleteError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
  /**
   * This method is calling the http call to fetch locations from the webservice Wdg2 (create or update depending if the location exists or not)
   *
   * @param  {Vuex} {dispatch} necessary if call dispatch inside the method
   * @param  {Object - LogInUser} logInUser user dg2
   * @returns {} it is returning nothing. The database is updated directly in the Back-End when the method is called.
   */
  async fetchLocationsDG2({ dispatch }, { logInUser }) {
    await fetchAllLocationsDG2Http(logInUser)
      .then((response) => {
        if (response.status === 202) {
          dispatch("loadLocations");
          dispatch(
            "notificationModule/showNotification",
            {
              messageAlert: i18n.t("messageStores.locationAllSuccess"),
              typeAlert: "success",
            },
            { root: true }
          );
        }
      })
      .catch((error) => {
        dispatch(
          "notificationModule/showNotification",
          {
            messageAlert: i18n.t("messageStores.locationAllError"),
            typeAlert: "error",
          },
          { root: true }
        );
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
